import styled from 'styled-components';

import { colors, media, Theme } from '../../../core';
import Icon from '../Icon';
import Text from '../Text';

export const UpperSection = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.medium || '24px'};
  align-items: center;

  ${media.xsmall} {
    flex-direction: column;
    & > div {
      width: 100%;
    }
  }

  p {
    padding: initial;
    line-height: initial;
    margin-bottom: 8px;
  }
`;

export const Timezone = styled(Text)`
  margin-bottom: ${({ theme }) => theme.spacing.medium || '24px'};
`;

export const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
`;

export const NavButton = styled.button.attrs({ type: 'button' })`
  -webkit-appearance: none;
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled,
  &[disabled] {
    cursor: default;
    opacity: 0.5;
  }
`;

export const IconLeft = styled(Icon)`
  margin-right: 4px;
`;

export const IconRight = styled(Icon)`
  margin-left: 4px;
`;

export const Row = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 14.3%);
  row-gap: 20px;
  padding: ${({ theme }) => theme.spacing.medium || '24px'} 0;

  ${media.xsmall} {
    grid-template-columns: 1fr;
    row-gap: 0;
  }
`;

export const Column = styled.div`
  border-right: 1px solid ${colors.neutral400};
  display: flex;
  flex-direction: column;
  align-items: center;

  &:nth-child(7n + 7) {
    border-right: 0;
  }

  ${media.xsmall} {
    border-right: 0;
  }
`;

export const ColumnTitle = styled.div`
  margin-bottom: 34px;
  min-width: 90px;
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const TitleDay = styled(Text)<{ selected: boolean }>`
  color: ${({ theme }) =>
    (theme.name === Theme.theme1 ? theme.fontColor : theme.fontColorSecondary) || colors.ash};
  margin: 0;
  font-weight: 500;
  line-height: 1.2;
  font-size: 12px;
`;

export const TitleFullDate = styled(Text)<{ selected: boolean }>`
  margin: 0;
  font-weight: ${({ selected }) => (selected ? 800 : 500)};
  line-height: 1.2;
  text-transform: uppercase;
  font-size: 12px;
`;

export const SlotButton = styled.button.attrs({ type: 'button' })<{
  isSelected: boolean;
}>`
  -webkit-appearance: none;
  background-color: ${({ isSelected, theme }) =>
    isSelected
      ? theme.bookingCalendarSlotBackgroundColorActive
      : theme.bookingCalendarSlotBackgroundColor};
  border: ${({ isSelected, theme }) =>
    isSelected
      ? `2px solid ${theme.bookingCalendarSlotBorderColorActive}`
      : `1px solid ${theme.bookingCalendarSlotBorderColor}`};
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  width: 80%;
  height: 55px;
  margin-bottom: 16px;
  transition: background-color 0.3s;
  padding: 0 5px;

  &:hover {
    background-color: ${({ theme }) =>
      theme.bookingCalendarSlotBackgroundColorActive || colors.neutral100};
    transition: background-color 0.3s;
  }

  ${media.xsmall} {
    width: 100%;
    min-width: 100%;
  }
`;

export const SlotTime = styled.span`
  color: ${({ theme }) => theme.fontColor || colors.ash};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.bookingCalendarSlotsFontWeight || 600};
  line-height: 20px;
  text-decoration: none;
  text-align: center;
  text-transform: uppercase;
`;

export const SlotAvailabilityMessage = styled.span`
  font-family: ${({ theme }) => theme.fontFamily};
  display: block;
  color: ${colors.rock};
  font-size: 12px;
  font-weight: 500;
`;

export const EmptySlots = styled.div`
  display: flex;
  padding: 0 24px;
  align-items: center;
  text-align: center;

  ${media.xsmall} {
    p {
      text-align: center;
      font-size: 14px;
    }
  }
`;
